<template>
	<div
		class="main-loading-panel modal-body accept-terms-wrapper"
		style="background-color: #ffffff;"
	>
		<div v-if="!hasAccepted" class="accept-terms">
			<div>
				<img src="/images/pronto/pronto-logo-name-white.png" />
			</div>

			<div
				style="margin-top: 30px; margin-bottom: 10px;"
				class="pronto-terms-image"
			>
				<img src="/images/pronto/Pronto-Apps.png" />
			</div>

			<div class="accept-terms-lgtext">
				{{ $t('onboarding_accept_terms_title') }}
			</div>

			<button class="accept-terms-btn" @click="acceptTerms()">
				{{ $t('common_button_continue') }}
			</button>

			<div
				class="accept-terms-and-service"
				v-html="
					$t('onboarding_phone_termsofservice', {
						TermsUrl: 'https://www.pronto.io/user-terms',
						PrivacyUrl: 'https://www.pronto.io/privacy',
					})
				"
			></div>
		</div>

		<MobilePrompt v-if="hasAccepted" />
	</div>
</template>

<script>
import store from '../store'
import { post } from '../helpers/api'

import MobilePrompt from './MobilePrompt'

export default {
	components: { MobilePrompt },
	data() {
		return {
			store,
			hasAccepted: false,
		}
	},

	methods: {
		acceptTerms() {
			//whatever endpoint server endpoint for accepting terms goes here
			post('/api/v1/user.accepttos')
				.then(({ data }) => {
					this.store.auth.user.acceptedtos = data.user.acceptedtos
					this.store.auth.user.hasactivity = true
					this.store.auth.setUser(this.store.auth.user, this.store.userKey)
					localStorage.setItem('acceptedtos', data.user.acceptedtos)
					if (this.store.auth.user.hasmobileapp) {
						this.store.termsPrompt = false
					} else {
						this.hasAccepted = true
					}
				})
				.catch((error) => {
					if (error.response == undefined) {
						return
					}

					switch (error.response.data.error) {
						default:
							console.error(
								'Unhandled error in AcceptTerms.vue acceptTerms() - ' +
									error.response.data.error
							)
							break
					}
				})
		},
	},
}
</script>
<style scoped>
.accept-terms-wrapper {
	background-image: url('/images/pronto/angle-background-large.png');
	background-repeat: no-repeat;
	background-position: center top;
	background-size: 100%;
	min-height: 100vh;
}

.accept-terms {
	text-align: center;
	padding-top: 40px;
	margin: 0 auto;
	max-width: none;
	padding-left: 20px;
	padding-right: 20px;
}

.accept-terms-btn {
	width: 311px;
	height: 50px;
	border-radius: 28px;
	background-color: #448de6;
	color: #ffffff;
	font-size: 14px;
	font-family: Avenir-Heavy;
	margin-top: 20px;
	margin-bottom: 15px;
	border: none;
	cursor: pointer;
}

.accept-terms-lgtext {
	font-size: 20px;
	font-family: Avenir-Heavy;
	color: #2c2d30;
	padding-left: 100px;
	padding-right: 100px;
}

.accept-terms-and-service {
	font-size: 14px;
	font-family: Avenir-Book;
	color: #454959;
}

.accept-terms-and-service :deep(a) {
	font-size: 14px;
	font-family: Avenir-Heavy;
	color: #448de6;
	text-decoration: none;
	font-weight: normal;
}

/* Wide screen adjustments to better handle the textured background in the header */
@media (min-width: 768px) {
	.accept-terms-wrapper {
		display: flex;
		justify-content: center;
		align-items: flex-start;
		background-size: cover;
		background-position: center top;
	}

	.accept-terms {
		max-width: 600px;
		margin-top: 60px;
	}

	.accept-terms-lgtext {
		padding-left: min(100px, 15%);
		padding-right: min(100px, 15%);
	}

	.accept-terms-and-service {
		max-width: 400px;
		margin: 0 auto;
		line-height: 1.4;
	}
}

/* Ultra-wide screen improvements to better handle the textured background in the header */
@media (min-width: 1400px) {
	.accept-terms-wrapper {
		background-size: 100% auto;
		background-position: center top;
	}

	.accept-terms {
		max-width: 700px;
		margin-top: 80px;
	}
}

@media (max-width: 767px) {
	.accept-terms-lgtext {
		padding-left: 100px;
		padding-right: 100px;
	}
}
</style>
